var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sensitive fs-warning"},[_vm._v("\n  "+_vm._s(_vm.$t('message["345"]'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }